import axios from "axios"
import { Data } from "~/types/dataTypes"

export async function submitSignup(data: Data) {
  const response = await axios.post("/index", data)
  return response.data
}
